export default __webpack_public_path__ + "static/media/Supari.490f98a9.png";